module.exports = __webpack_public_path__ + "media/images/kinetix_hero_image-501344f496548ac57a070b6265374c44.jpeg";